module.exports = __webpack_public_path__ + "static/media/07_2.738fd042.png";